import { render, staticRenderFns } from "./government.vue?vue&type=template&id=14ffdaa7&"
import script from "./government.vue?vue&type=script&lang=js&"
export * from "./government.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports